import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const puasaSyawalMuslim1164: Quote = {
  id: "puasa-syawal-muslim-1164",
  name: "6 Hari Syawal = Setahun Penuh",
  emoji: "🌙",
  category: "Ibadah & Ramadhan",
  description:
    "Puasa 6 hari di bulan Syawal setelah Ramadhan, pahalanya **setara puasa setahun penuh**. Bukan kiasan — ada hitungan matematis di baliknya.",
  detail:
    "Hadits riwayat Muslim no. 1164 menjelaskan bahwa siapa yang berpuasa Ramadhan lalu mengiringinya dengan 6 hari di bulan Syawal, maka seakan-akan ia berpuasa setahun penuh. Hitungannya: setiap kebaikan dilipatgandakan 10 kali (QS. Al-An'am: 160). Ramadhan 30 hari × 10 = 300 hari. Syawal 6 hari × 10 = 60 hari. Total = 360 hari — setahun penuh dalam kalender Hijriah.",
  tldr: "Puasa Ramadhan + 6 hari Syawal = pahala setahun penuh. Ada matematikanya.",
  story: createQuoteStory("6 Hari Syawal = Setahun Penuh", "🌙", [
    { hook: {
      title: "6 hari untuk pahala setahun.",
      body: "Sudah **puasa Syawal** belum?",
    } },
    { source: {
      arabic:
        "مَنْ صَامَ رَمَضَانَ ثُمَّ أَتْبَعَهُ سِتًّا مِنْ شَوَّالٍ كَانَ كَصِيَامِ الدَّهْرِ",
      body: "Barangsiapa berpuasa Ramadhan, lalu mengiringinya dengan **6 hari** di bulan Syawal, maka seakan-akan ia **berpuasa setahun penuh**.",
      title: "HR. Muslim no. 1164",
    } },
    { source: {
      arabic:
        "مَن جَاءَ بِالْحَسَنَةِ فَلَهُ عَشْرُ أَمْثَالِهَا",
      body: "Barangsiapa berbuat satu kebaikan, maka baginya **sepuluh kali lipatnya**.",
      title: "QS. Al-An'am: 160",
    } },
    { reveal: {
      title: "Ini hitungannya.",
      body: "Ramadhan 30 hari × 10 = **300 hari**.\nSyawal 6 hari × 10 = **60 hari**.\n\nTotal = **360 hari** — setahun penuh dalam kalender Hijriah.",
    } },
    { insight: {
      title: "Boleh dicicil, boleh berturut-turut.",
      body: "Tidak harus 6 hari berturut-turut. Boleh dicicil sepanjang Syawal — yang penting **6 hari terpenuhi** sebelum bulan berganti.",
    } },
    { engagement: {
      title: "Ramadhan sudah selesai.",
      body: "Tapi 6 hari di depanmu bisa **mengunci pahala setahun penuh**.\n\nNiatkan mulai besok.",
    } },
  ]),
  tiktok: {
    title: "6 hari puasa Syawal = pahala setahun. Ini hitungan matematisnya.",
    description: "Ramadhan 30 hari × 10 = 300. Syawal 6 hari × 10 = 60. Total = 360 = setahun penuh. Bukan kiasan, ini janji Allah.\n\n#puasasyawal #syawal #ramadhan #puasa #islam #sunnah #pahala #fyp",
  },
  related: ["istiqamah-fussilat-30"],
};
